import { useCallback, useMemo } from "react";
import { Game } from "../interfaces/game.interface";
import { navigate } from "../utilities/CustomRoute/Navigate";
import { GAMES_ENABLED, QA_MODE } from "../utilities/url";
import { userStore } from "../gStore/user.store";
import { userService } from "../services/user.service";

export const useGameNavigator = (game: Game | undefined | null) => {
  const isGamePlayable = useMemo(() => GAMES_ENABLED && (game?.link || game?.staging_link), [game]);

  const navigateToGame = useCallback(
    (forceDetails?: boolean) => {
      if(!game) return;

      if (isGamePlayable && !forceDetails) {
        userService.playGame(userStore.data.user.id, game.id);
        const gameURL =
          QA_MODE && game.staging_link ? game.staging_link : game.link;
        window.location.href = gameURL + `?userId=${userStore.data.user.id}`;
      } else {
        navigate("game-detail", { gameId: game.id });
      }
    },
    [isGamePlayable, game]
  );

  return {
    isGamePlayable,
    navigateToGame,
  };
};
